import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FieldVersionService, FieldVersionsData, FieldVersionsRes, PromptDialogService, IDialogOptions,
} from '@lc/core';
import { map } from 'rxjs/operators';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { AsyncPipe, DatePipe } from '@angular/common';
import { E2eIdDirective } from '@lc/ui';
import { HeaderComponent } from '../../../../../ui/src/lib/layout/header/header.component';
import { CardComponent } from '../../../../../ui/src/lib/cards/components/card/card.component';

@Component({
  selector: 'lc-field-version',
  templateUrl: './field-version.component.html',
  styleUrls: ['./field-version.component.scss'],
  imports: [
    CardComponent,
    HeaderComponent,
    MatIconButton,
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    AsyncPipe,
    DatePipe,
    E2eIdDirective,
  ],
})
export class FieldVersionComponent {
  private fieldVersionService = inject(FieldVersionService);
  dialogRef = inject<MatDialogRef<FieldVersionComponent>>(MatDialogRef, { optional: true });
  data = inject<FieldVersionsData>(MAT_DIALOG_DATA);

  displayedColumns: string[] = ['modifiedTime', 'userFullName', 'key', 'value'];
  readonly fieldVersions$: Observable<any>;

  constructor() {
    const { data } = this;

    this.fieldVersions$ = this.fieldVersionService.create$(data).pipe(
      map((returnVersions) => returnVersions || [new FieldVersionsRes()]),
    );
  }

  onClose() {
    this.dialogRef?.close(undefined);
  }

  static async open(service: PromptDialogService, data?: FieldVersionsData, options?: IDialogOptions): Promise<any> {
    const defaultOptions: IDialogOptions = {
      width: '900px', disableClose: false, panelClass: 'p-0', autoFocus: false,
    };
    const opts: IDialogOptions = Object.assign(defaultOptions, options);
    return await service.openComponent(FieldVersionComponent, data, opts);
  }
}
